import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-grip-vertical',
    templateUrl: './grip-vertical.component.svg',
    styleUrls: ['./grip-vertical.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GripVerticalComponent {}
